import { render, staticRenderFns } from "./Assessment-details-editable.vue?vue&type=template&id=536fc61c&scoped=true"
import script from "./Assessment-details-editable.vue?vue&type=script&lang=js"
export * from "./Assessment-details-editable.vue?vue&type=script&lang=js"
import style0 from "./Assessment-details-editable.vue?vue&type=style&index=0&id=536fc61c&prod&scoped=true&lang=css"
import style1 from "./Assessment-details-editable.vue?vue&type=style&index=1&id=536fc61c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536fc61c",
  null
  
)

export default component.exports